import React, {  } from 'react'
import { useFormik } from "formik";
import { connect, useSelector } from "react-redux";
import {useHistory} from 'react-router-dom'
//Acciones redux
import { editFranchise } from "../../actions/franchiseeActions";
import { Translate } from '../../language';
import EditEcoTienda from '../../containers/Requests/RequestEcoTiendaOrMaster/EditEcoTienda';

//Componetnes
//import { Places } from "../../../components/form/Places";


function EditFranchisee({
  //Funcion Redux
  editFranchise,
  ...props
}) {
  // const {logging} = useSelector((state) => state.auth.login)
  const { userInfo } = useSelector(state => state.userInfo)
  const history = useHistory()
  const validate = (values) => {
    const errors = {};
    return errors;
  };


  const formik = useFormik({
    enableReinitialize:true,
    initialValues: {

      businessEmail: userInfo?.franchiseID?.businessEmail || '',
      businessPhone: userInfo?.franchiseID?.businessPhone || '',

      socialReason: userInfo?.franchiseID?.socialReason || '',
 
     
      businessCountry: userInfo?.franchiseID?.ubication?.businessCountry || '',
      businessDepartment: userInfo?.franchiseID?.ubication?.businessDepartment || '',
      businessCity: userInfo?.franchiseID?.ubication?.businessCity || '',
      businessLocation: userInfo?.franchiseID?.ubication?.businessLocation || '',
      businessAddress: userInfo?.franchiseID?.ubication?.businessAddress || '',

     // identificationNumber: '',
    },
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append('franchiseID',userInfo.franchiseID._id)
      for (var key in values) {
          formData.append(key, values[key]);
      }
      
      editFranchise(formData,history)

    },

  });
return <EditEcoTienda tittle={Translate('requestFranchisee', 'es')} formik={formik}/>
  
}


export default connect(null, { editFranchise })(EditFranchisee);
